 // 保存 excel 文件
 export default function fileDownload(data, fileName){
    // 这里 data 就是后台响应的二进制数据流
  let blob = new Blob([data], {type: 'application/vnd.ms-excel,charset=utf-8' });
  // 没有指定下载的名称 默认filename.xls
  let filename = fileName || "filename.xls";
  // 有 msSaveBlob  直接保存
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    window.navigator.msSaveBlob(blob, filename);
  } else { // 没有
    // 创建 blobURL 
    var blobURL = window.URL.createObjectURL(blob);
    // 创建 a 标签
    var tempLink = document.createElement("a");
    // 隐藏 a 标签
    tempLink.style.display = "none";
    // 设置 a 标签 href 连接
    tempLink.href = blobURL;
    // 设置 a 标签属性为 download (下载文件)
    tempLink.setAttribute("download", filename);
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}